const carDetails = {
    EN: {
        vehicle: 'Vehicle',
        history: 'History',
        planning: 'Planning',
        animation: 'Animation',
        alerts: 'Alerts',
        latestUpdate: 'Latest update',
        vehicleName: 'Name',
        address: 'Address',
        coords: 'Coordinates',
        time: 'Time',
        stopTime: 'Stop time',
        mileage: 'Mileage',
        journeyData: 'Journey Data',
        distanceWeek: 'Distance (week)',
        distanceCurrent: 'Current',
        distancePrevious: 'Previous',
        noDataTitle: 'No data to show',
        noDataDescription: 'Click on any vehicle icon on map to see its details.',
        vehicleSpeed: 'Vehicle speed',
        latestUpdateDataframe: 'Latest update',
        deviceId: 'Device ID',
        terminalId: 'Terminal ID',
        vin: 'VIN',
        turnedOn: 'Car turned on',
        vehicleCategory: 'Vehicle category',
        satellite: 'Satellite count',
        licensePlate: 'License plate',
        PASSENGER_CAR: 'Passenger car',
        VAN: 'VAN',
        TRUCK: 'Truck',
        carCategory: 'Car category',
        noDataRideHistoryDescription: 'No ride history data for choosen vehicle.',
        noRidesForGivenPeriod: 'No ride data for given period.',
        noRidesForGivenPeriodTitle: 'No rides',
        duration: 'Duration',
        averageSpeedKmh: 'Average speed',
        distanceKilometers: 'Distance',
        startDate: 'Start ride date',
        endDate: 'End ride date',
        driver: 'Driver',
        distanceKilometersGPS: 'GPS distance',
        maxspeed: 'Max speed',
        fuelLevelLitres: 'Fuel level',
        fuelConsumption: 'Fuel consumption',
        name: 'Name',
        distanceMonth: 'Distance month',
        stopSince: 'Stop since',
        noImageAvailable: 'No image available',
        addFleet: 'Add Fleet',
        edit: 'Edit',
        delete: 'Delete',
        addAlert: 'Add Alert',
        SPEEDING: 'Speeding',
        ENTERING_AREA: 'Entering area',
        LEAVING_AREA: 'Leaving area',
        fleetName: 'Fleet name',
        creationDate: 'Creation date',
        carNameNew: 'Name',
        allowedSpeed: 'Allowed speed',
        fleets: 'Fleet',
        cars: 'Cars',
        zones: 'Zones',
        zoneType: 'Type',
        title: 'Title',
        assigned: 'Assigned',
        passages: 'Passages',
        add: 'Add',
        carModel: 'Model',
        carManufacturer: 'Manufacturer',
        latestDataframeDateTime: 'Latest dataframe date',
        gsmSignal: 'GSM signal',
        carDiagnostic: 'Car diagnostic',
        turnOffCar: 'Turn off car',
        turnOffSim: 'Turn off SIM',
        turnOnCarAgain: 'Turn on again',
        carHistory: 'Car history',
        alertHistory: 'Alert history',
        model: 'Model',
        speedGps: 'Speed',
        latLng: 'Lat & Lng',
        MACHINE: 'Machine',
        SEMI_TRAILER: 'Semi trailer',
        domain: 'Domain',
        event: 'Event',
        acceleration: 'Acceleration',
        accelerationX: 'Acceleration X',
        accelerationY: 'Acceleration Y',
        accelerationZ: 'Acceleration Z',
        mileageGps: 'GPS mileage',
        carId: 'Car ID',
        speedLimitKmh: 'Speed limit [km/h]',
        inRideFromNow: 'In ride from',
        latestStop: 'Latest stop',
        dateTime: 'Date',
        latitude: 'Latitude',
        longitude: 'Longitude',
        yes: 'Yes',
        no: 'No',
        backupPowerSupplyVoltage: 'Backup power supply voltage',
        mainPowerSupplyVoltage: 'Main power supply voltage',
        latestDataFrame: 'Latest dataframe',
        heading: 'Heading',
        collisionDate: 'Collision date',
        overNDays: 'Over _n_ days',
        noActivity: 'No activity from',
        turnOffWhen: 'Turn off will be',
        activeStatus: 'Active status',
        turnOffCarTitle: 'Turn off car',
        turnOffStep1: 'Choose turn off date.',
        turnOffStep2: 'Apply turn off by clicking confirn button.',
        turnOffStep3: 'Car will be automatically turn of this day.',
        turnOffDate: 'Turn off date',
        turnOff: 'Turn off vehicle',
        isTurnedOn: 'Is turned on',
        isTurnedOff: 'Is turned off',
        SHOW_IN_GOOGLE_MAPS: 'Go to Google Maps'
    },
    PL: {
        vehicle: 'Pojazd',
        history: 'Historia',
        planning: 'Planowanie',
        animation: 'Animacja',
        alerts: 'Alerty',
        latestUpdate: 'Ostatnia aktualizacja',
        vehicleName: 'Nazwa',
        address: 'Adres',
        coords: 'Współrzędne geograficzne',
        time: 'Czas',
        stopTime: 'Czas postoju',
        mileage: 'Przebieg',
        journeyData: 'Liczniki podróży',
        distanceWeek: 'Dystans tydzień',
        distanceCurrent: 'Bieżący',
        distancePrevious: 'Poprzedni',
        noDataTitle: 'Brak danych do wyświetlenia',
        noDataDescription: 'Kliknij na jeden z pojazdów na mapie aby zobaczyć szczegóły.',
        vehicleSpeed: 'Prędkość pojazdu',
        latestUpdateDataframe: 'Ostatnia aktualizacja danych',
        deviceId: 'ID urządzenia',
        terminalId: 'ID terminala',
        vin: 'VIN',
        turnedOn: 'Pojazd uruchomiony',
        vehicleCategory: 'Kategoria pojazdu',
        satellite: 'Satelity',
        licensePlate: 'Nr rejestracyjny',
        PASSENGER_CAR: 'Samochód osobowy',
        VAN: 'VAN',
        TRUCK: 'Samochód ciężarowy',
        MACHINE: 'Maszyna',
        SEMI_TRAILER: 'Naczepa',
        carCategory: 'Kategoria pojazdu',
        noDataRideHistoryDescription: 'Brak historii przejazdów dla wybranego pojazdu.',
        noRidesForGivenPeriod: 'Brak przejazdów dla wybranego okresu',
        noRidesForGivenPeriodTitle: 'Brak przejazdów',
        duration: 'Czas trwania przejazdu',
        averageSpeedKmh: 'Średnia prędkość',
        distanceKilometers: 'Przebyty dystans',
        startDate: 'Początek trasy',
        endDate: 'Koniec trasy',
        driver: 'Kierowca',
        distanceKilometersGPS: 'Dystans GPS',
        maxspeed: 'Maksymalna prędkość',
        fuelLevelLitres: 'Paliwo',
        fuelConsumption: 'Spalanie',
        name: 'Nazwa',
        distanceMonth: 'Dystans miesiąc',
        inRideFromNow: 'W trasie od',
        latestStop: 'Ostatni postój',
        fuelStatus: 'Stan paliwa',
        engineSpeed: 'Obroty silnika',
        vehicleId: 'ID pojazdu',
        stopSince: 'Postój od',
        noImageAvailable: 'Brak zdjęcia dla wybranego pojazdu',
        addFleet: 'Dodaj flotę',
        edit: 'Edytuj',
        delete: 'Usuń',
        addAlert: 'Dodaj alert',
        SPEEDING: 'Przekroczenie prędkości',
        ENTERING_AREA: 'Wjazd do strefy',
        LEAVING_AREA: 'Wyjazd ze strefy',
        fleetName: 'Nazwa floty',
        creationDate: 'Data utworzenia',
        carNameNew: 'Nadaj nazwę',
        allowedSpeed: 'Dopuszczalna prędkość',
        fleets: 'Floty',
        cars: 'Pojazdy',
        zones: 'Obszary',
        zoneType: 'Rodzaj',
        title: 'Nazwa',
        assigned: 'Przypisane',
        passages: 'Przejazdy',
        add: 'Dodaj',
        info: 'Informacje',
        warnings: 'Ostrzeżenia',
        alertsCount: 'Ilość',
        noHistoryAlertData: 'Brak wywołanych powiadomień w wybranym okresie.',
        carModel: 'Model',
        carManufacturer: 'Marka',
        latestDataframeDateTime: 'Data ostatniej ramki',
        gsmSignal: 'Zasięg sieci',
        acceleration: 'Przyspieszenie',
        accelerationX: 'Przyspieszenie X',
        accelerationY: 'Przyspieszenie Y',
        accelerationZ: 'Przyspieszenie Z',
        carDiagnostic: 'Diagnostyka pojazdu',
        turnOffCar: 'Wyłącz samochód',
        turnOffSim: 'Wyłącz kartę SIM',
        turnOnCarAgain: 'Włącz ponownie',
        carHistory: 'Historia pojazdu',
        alertHistory: 'Historia alertów',
        speedLimitExceedance: 'Poziom przekroczenia prędkości',
        speedLimitKmh: 'Ograniczenie prędkości',
        mileageGps: 'Przebieg GPS',
        heading: 'Skierowanie pojazdu',
        dateTime: 'Data ramki',
        latitude: 'Szerokość geograficzna',
        longitude: 'Długość geograficzna',
        yes: 'Tak',
        no: 'Nie',
        carId: 'Id pojazdu',
        backupPowerSupplyVoltage: 'Napięcie zasilania zapasowego',
        mainPowerSupplyVoltage: 'Napięcie zasilania głównego',
        latestDataFrame: 'Ostatnia ramka',
        model: 'Model',
        speedGps: 'Prędkość',
        latLng: 'Dł. i sz. geograficzna',
        domain: 'Strefa',
        event: 'Zdarzenie',
        collisionDate: 'Data wypadku',
        overNDays: 'Ponad _n_ dni',
        noActivity: 'Brak aktywności od',
        turnOffWhen: 'Wyłączenie nastąpi',
        activeStatus: 'Status aktywności',
        turnOffCarTitle: 'Wyłączenie samochodu',
        turnOffStep1: 'Wybierz datę wyłączenia samochodu.',
        turnOffStep2: 'Potwierdź wyłączenie klikając wyślij.',
        turnOffStep3: 'Samochód zostanie automatycznie wyłączony tego dnia.',
        turnOffDate: 'Data wyłączenia',
        turnOff: 'Wyłączenie pojazdu',
        isTurnedOn: 'Włączony',
        isTurnedOff: 'Wyłączony',
        SHOW_IN_GOOGLE_MAPS: 'Przejdź do Google Maps'
    }
};

export default carDetails;



// WEBPACK FOOTER //
// ./src/Translations/CarDetails.ts